import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { BehaviorSubject, Observable, catchError, map, tap } from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class AlertService extends BehaviorSubject<any[]> {
  private data: any[] = []
  constructor(
    private _http: HttpClient,
    private toastrService: ToastrService,
  ) {
    super([])
  }
  public read() {
    if (this.data.length) {
      return super.next(this.data)
    }
    this.fetch()
      .pipe(
        tap((data) => {
          this.data = data
        }),
      )
      .subscribe((data) => {
        super.next(data)
      })
  }
  removeuser(r: any): Observable<any> {
    return this._http.post<any>('/api/Types/RemoveccemailUser', r).pipe(
      tap((event) => {
        this.reset()
        this.read()
        this.fetch('destroy', r)
      }),
    )
  }
  savAlertcc(r: any): Observable<any> {
    return this._http.post<any>('/api/Types/SaveAlertInfo', r).pipe(
      tap((event) => {
        this.reset()
        this.read()
        this.fetch('destroy', r)
      }),
    )
  }
  getBlotterExportReportsAll(d: any): Observable<any> {
    return this._http
      .post('/api/Types/GetBranchTransactionsReports', d, {
        responseType: 'blob'
      })
      .pipe(catchError(this.handleError))
  }
  getBlotterExportReports(d: any): Observable<any> {
    return this._http
      .post('/api/Types/GetBranchTransactionsReports', d, {
        responseType: 'blob'
      })
      .pipe(catchError(this.handleError))
  }
  getAccessReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetAccessReports', d)
      .pipe(catchError(this.handleError))
  }
  getAccessTrasactionReports(d: any): Observable<any> {
    return this._http
      .post('/api/Types/GetTransactionReportExcel', d, {
        responseType: 'blob'
      })
      .pipe(catchError(this.handleError))
  }
  getDeletedBlottersReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetDeletedBlotterReports', d)
      .pipe(catchError(this.handleError))
  }
  getAccessExportReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetAccessexReports', d)
      .pipe(catchError(this.handleError))
  }
  getvaribleAnnunityAge(r: any): Observable<Blob> {
    return this._http
      .post(`/api/Reports/GetVaAgeReport`, r, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getDeletedExportBlottersReports(d: any): Observable<any> {
    return this._http
      .post<any>('/api/Types/GetDeletedBlotterExportReports', d)
      .pipe(
        tap((value) => {
          if (Array.isArray(value) && value.length === 0) {
          }
        }),
        catchError(this.handleError),
      )
  }
  private fetch(action: string = '', data?: any): Observable<any[]> {
    return this._http
      .get(`/api/Types/getEmailAlertusers`)
      .pipe(map((res) => <any[]>res))
  }
  private reset() {
    this.data = []
  }
  
  // Use arrow function to preserve 'this' context
  private handleError = (error: Response | any) => {
    let errMsg: string

    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    this.showToast('error', 'Sorry there was a error')
    return Promise.reject(errMsg)
  }
showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}
